import { render, staticRenderFns } from "./SlideFormPFA.vue?vue&type=template&id=5879161d&scoped=true"
import script from "./SlideFormPFA.vue?vue&type=script&lang=js"
export * from "./SlideFormPFA.vue?vue&type=script&lang=js"
import style0 from "./SlideFormPFA.vue?vue&type=style&index=0&id=5879161d&prod&scoped=true&lang=css"
import style1 from "./SlideFormPFA.vue?vue&type=style&index=1&id=5879161d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879161d",
  null
  
)

export default component.exports